import { FC } from 'react'
import { FiltersAndSearchWrapper, FiltersWrapper } from 'views/components/CommonTableComponents/CommonTableComponents'
import { useDisplayClearBtn } from 'hooks/useDisplayClearBtn'
import { TableFiltersProps } from 'modules/types'
import { AClearFiltersButton } from 'views/components/Analytics'
import { useTranslation } from 'react-i18next'
import { ABaseTableFilter } from 'views/components/TableFilters/ABaseTableFilter'
import { endpoints } from 'modules/endpoints'
import { ListRequestParams } from 'modules/domain/types'

type Props = Omit<TableFiltersProps, 'setListRequestParams'> & {
  clearTabState: (params: Partial<ListRequestParams>) => void
}

export const CarrierFilters: FC<Props> = ({
  clearTabState,
  listRequestParams,
  updateFilterState,
  defaultFilterValues,
}) => {
  const { t } = useTranslation('logisticsKR')
  const displayClearBtn = useDisplayClearBtn({
    listRequestParams,
    defaultFilters: defaultFilterValues,
  })

  return (
    <FiltersAndSearchWrapper>
      <FiltersWrapper>
        <ABaseTableFilter
          id="logisticianFilter"
          placeholder={t('list.filters.logistician')}
          value={listRequestParams.filter.responsible_logistician}
          endpoint={endpoints.dispatchingLogisticians()}
          onChange={(responsible_logistician) => updateFilterState({ responsible_logistician })}
          getLabel={(dto) => dto.full_name}
          searchField="search"
          showSearch={true}
        />
        <ABaseTableFilter
          id="logisticianFilter"
          placeholder={t('list.filters.carrier')}
          value={listRequestParams.filter.carrier}
          endpoint={endpoints.LogisticsKR.carriers()}
          onChange={(carrier) => updateFilterState({ carrier })}
          getLabel={(dto) => dto.name}
          searchField="search"
          showSearch
        />
        {displayClearBtn && (
          <AClearFiltersButton onClick={() => clearTabState({ ...{ filter: defaultFilterValues } })} />
        )}
      </FiltersWrapper>
    </FiltersAndSearchWrapper>
  )
}
